/* 
UNIT-FILTERS.TSX
List of unit you can click in order to filter risks
*/

import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import unitStore from "../model/unit.store"
import { Session } from "@/redux/_session.types"
import { FadeIn } from "@/utils/animations.utils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUser, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons"
import { useState } from "react"
import { orderBy } from "lodash"
import riskStore from "../../risk/model/risk.store"
import Link from "@/components/link"
import Space from "@/components/space"

export default function UnitFilters() {
  const dispatch = useAppDispatch()

  //Selectors
  const _session: Session = useAppSelector((state) => state._session)
  const units = useAppSelector(unitStore.selectors.list)
  const selected = useAppSelector(unitStore.selectors.selected)
  const risks = useAppSelector(riskStore.selectors.list)

  const unitsWithRisks = units.filter((unit) => risks.some((risk) => risk.UnitId === unit.id))

  //Is open
  const [isOpen, setIsOpen] = useState(false)

  return unitsWithRisks.length > 1 ? (
    <div>
      <FadeIn className={"flex flex-1 rel flex-wrap risks-unit-filters " + (isOpen ? "risks-unit-filters-open" : "")}>
        {orderBy(unitsWithRisks, ["isSelf"], ["desc"]).map((unit) => {
          const isSelected = Array.isArray(selected) ? selected.includes(unit.id) : selected === unit.id
          return (
            <div
              key={unit.id}
              className={`filters-item flex ${isSelected ? "filters-item-active" : "filters-item-activable"}`}
              onClick={() => dispatch(unitStore.actions.select(unit.id))}
              style={{
                color: isSelected ? _session.accountColors.active : ""
              }}>
              {unit.name}
              {unit.size && (
                <div className="mt-[1px] ml-2 text-sm">
                  <FontAwesomeIcon icon={faUser} />
                  &nbsp;
                  {unit.size}
                </div>
              )}
              <div className="mt-[1px] ml-2 text-sm">
                <FontAwesomeIcon icon={faTriangleExclamation} />
                &nbsp;
                {risks.filter((r) => r.UnitId === unit.id).length}
              </div>
            </div>
          )
        })}
      </FadeIn>
      <div className="flex mt-2">
        <Space />
        <Link isWithoutMargin onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? "Réduire l'affichage des unités" : "Afficher toutes les unités"}
        </Link>
      </div>
    </div>
  ) : null
}
